import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { MOCK_API } from '../config/api.config';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';
import { TecnicaDiagnostica } from '../models/';

@Injectable()
export class TecnicasDiagnosticasService extends RESTService<any> {

  public tecnicaDiagnostica: TecnicaDiagnostica;

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/resumenPaciente',
    });
  }

  /**
   * getTecnicasDiagnosticas: obtiene el listado completo de tecnicasDiagnosticas de un paciente
   * @param pacienteId: string
   * @return any
   */
  obtenerTecnicasDiagnosticas(pacienteId: string, visita: string): any {
    // Parametros fijos
    let params: any = {
      iNumVisita: visita,
      iIdModulo: '1',
      iNumExpediente: pacienteId,
    };
    return this._http.post(environment.api_host + 'tecnicasDiagnosticas/obtenerTecnicasDiagnosticas', params).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  /**
   * guardarTecnicaTerapeutica
   * @param request: object
   * @return boolean
   */
  guardarTecnicaDiagnostica(params: any): Observable<boolean> {
    return this._http.post(environment.api_host + 'tecnicasDiagnosticas/guardarTecnicaDiagnostica', params).map((res: Response) => {
      let respuesta: any = res.json();
      if (respuesta.resultado === 'OK') {
        return true;
      } else {
        return false;
      }
    }).catch((error: any) => Observable.throw(false));
  }

  /**
   * eliminarTecnicasDiagnosticas
   * @param pacienteId: string
   * @param tecnicaDiagnosticaId: string
   * @return JSON Object
   */
  eliminarTecnicaDiagnostica(pacienteId: string, tecnicaDiagnosticaId: string): any {
    let res: any = {
      resultado: {
        estado: 'Ok',
        mensaje: 'Técnica Terapéutica borrada correctamente',
      },
    };
    return JSON.stringify(res);
  }
}



// WEBPACK FOOTER //
// ./src/services/tecnicasdiagnosticas.service.ts